import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useUser } from 'client/lib/User';
import { Button } from 'client/components/Button';
import { useClaimAccount } from 'client/components/Dialog/ClaimAccountDialog';
import { Navigation } from 'client/components/Navigation';
import { AlertBanner } from 'client/components/Other/AlertBanner';

export const Layout = () => {
  const user = useUser();
  const { open } = useClaimAccount();

  useEffect(() => {
    document.title = 'Diploi';
  }, []);

  // const { setError } = useError();
  // const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  // const { send } = useSocket({
  //   listeners: [
  //     {
  //       path: '/core/pending',
  //       handler: () => askForCoreSetup(),
  //     },
  //   ],
  // });

  // useEffect(() => {
  //   if (user.isPendingUpdate) return;
  //   if (user.isLoggedIn) lookupCores();
  // }, [user.isPendingUpdate, user.isLoggedIn]);

  // const lookupCores = async () => {
  //   const response = await send<LookupCoreRequest, LookupCoreResponse>('/core/lookup');

  //   if (response.status !== 'ok') {
  //     setError('Failed to lookup pending Diploi Cores', { status: response.status });
  //     return;
  //   }

  //   if (response.pending) askForCoreSetup();
  // };

  // const askForCoreSetup = () => {
  //   enqueueSnackbar(
  //     <div style={{ display: 'flex', alignItems: 'center' }}>
  //       Found a core trying to connect to this instance. Setup now?
  //       <Button onClick={setupCore} style={{ marginLeft: '1rem' }}>
  //         SETUP
  //       </Button>
  //     </div>,
  //     { key: 'core-setup', persist: true, preventDuplicate: true }
  //   );
  // };

  // const setupCore = async () => {
  //   closeSnackbar();

  //   const response = await send('/core/setup');
  //   if (response.status !== 'ok') {
  //     setError(response.status);
  //     return;
  //   }

  //   enqueueSnackbar(<div style={{ display: 'flex', alignItems: 'center' }}>Core setup succeeded!</div>, {
  //     key: 'core-setup-success',
  //     persist: false,
  //     preventDuplicate: true,
  //   });
  // };

  if (!user.isLoggedIn) return <Outlet />;

  return (
    <div style={{ overflow: 'auto' }}>
      <Navigation />

      {user.anonymousTrial && (
        <AlertBanner
          button={
            <Button small onClick={open}>
              Claim Account
            </Button>
          }
        >
          {user.anonymousTrial.softLimitMinutesLeft
            ? `This is a trial account and you have ${Math.floor(
                user.anonymousTrial.softLimitMinutesLeft
              )} minutes left to go. Please claim this account to continue testing`
            : `This account has not been claimed and will be removed in ${Math.ceil(
                user.anonymousTrial.hardLimitMinutesLeft / 60
              )} hours. Please claim this account to prevent deletion.`}
        </AlertBanner>
      )}

      <main>
        <Outlet />
      </main>
    </div>
  );
};
